// An investment's value is what has been paid into it (the server adds each instalment
// once it's marked Paid). With a yearly return % it is also worth an estimated amount:
// each paid instalment grows from the date it was paid, compounded yearly. Whatever
// part of the value came from before its instalments were tracked is counted as is.
const DAY = 86400000;

export const paidInstalments = (asset, bills) => bills.filter((b) => b.sourceKind === "asset" && b.sourceId === asset.id && b.status === "Paid");

// Null when there's no return % to estimate with.
export const estimatedValue = (asset, bills, today = new Date()) => {
  if (asset.category === "account" || asset.returnRate == null) return null;
  const r = asset.returnRate / 100;
  const paid = paidInstalments(asset, bills);
  const tracked = paid.reduce((s, b) => s + b.amount, 0);
  const grown = paid.reduce((s, b) => {
    const years = Math.max(0, (today - new Date(`${b.dueDate}T00:00:00`)) / (365.25 * DAY));
    return s + b.amount * Math.pow(1 + r, years);
  }, 0);
  return Math.max(0, asset.value - tracked) + grown;
};
